import React, {Fragment, useEffect, useState} from "react";
import ReactPaginate from "react-paginate";
import ResultsNotFound from "../ResultsNotFound";

const UiPaginate = (props) => {

    const [pager, setPager] = useState(props.pager)

    const [notFoundMessage, setNotFoundMessage] = useState({
        title: props.notFoundMessage?.title || 'Recurso não encontrato',
        detail: props.notFoundMessage?.detail || 'Desculpe, não conseguimos encontrar nenhum registro com os filtros informados. Por favor, revise as informações e tente novamente.'
    })

    const handlePageChange = ({selected}) => {
        if (props.onPageChange) {
            props.onPageChange({selected})
        }
    }

    useEffect(() => {
        setPager(props.pager)
    }, [props.pager])

    useEffect(() => {
        setNotFoundMessage(
            {
                title: props.notFoundMessage?.title || 'Recurso não encontrato',
                detail: props.notFoundMessage?.detail || 'Desculpe, não conseguimos encontrar nenhum registro com os filtros informados. Por favor, revise as informações e tente novamente.'
            }
        )
    }, [props.notFoundMessage])

    return (
        <Fragment>
            <div className={
                props.layout === 'left' ? 'd-flex justify-content-start' :
                    'd-flex justify-content-end'
            }>
                {
                    pager.results?.length > 0 &&
                    <Fragment>
                     <span
                         className="text-muted">Exibindo {pager.results.length + ((pager.pagination.page) * pager.pagination.limit)} de {pager.pagination.totalElements}</span>

                        <ReactPaginate
                            previousLabel={<i className="i-Previous"></i>}
                            nextLabel={<i className="i-Next1"></i>}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pager.pagination.totalPages}
                            forcePage={pager.pagination.page}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            onPageChange={handlePageChange}
                        />
                    </Fragment>
                }
            </div>

            {
                pager.results?.length === 0 && pager.pagination?.totalElements === 0 &&
                <ResultsNotFound
                    title={notFoundMessage.title}
                    detail={notFoundMessage.detail}
                />
            }

        </Fragment>
    );
};

export default UiPaginate;
